import { useState } from 'react';
import { Box } from '@mui/material';
import DownloadCard from './ReportCards/DownloadCard';
import MedicineDispenseCard from './ReportCards/MedicineDispenseCard';
import MedicalEventsCard from './ReportCards/MedicalEventsCard';
import DownloadReportPopup from '../Profiles/DownloadReportPopup/DownloadReportPopup';
import { useGetGroupFiltersQuery } from '../../../api/services/groupService';
import useUser from '../../../utility/hooks/useUser';

function ReportsTab() {
    const { user } = useUser();
    const isParentRole = user.isParent();
    const [renderReportType, setRenderReportType] = useState(undefined);

    const { data: groupFilters = { modules: [] } } = useGetGroupFiltersQuery(
        undefined,
        { skip: isParentRole },
    );

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 1,
                mt: 2,
                overflowY: 'auto',
            }}
        >
            <DownloadCard onSelect={setRenderReportType} />

            {!isParentRole && <MedicineDispenseCard groupFilters={groupFilters.modules} />}
            {!isParentRole && <MedicalEventsCard groupFilters={groupFilters.modules} />}

            <DownloadReportPopup
                open={Boolean(renderReportType)}
                groupFilters={groupFilters.modules}
                onClose={() => setRenderReportType(undefined)}
                isCsv={renderReportType === 'csv'}
            />
        </Box>
    );
}

export default ReportsTab;
